import {
  OwnerPortfolioQuery,
  PortfolioSituation,
} from "../types/ownerPortfolio.types";

export const OWNER_PORTFOLIO_ENDPOINT = "/api/client/owner/portfolio";

export const INSPECTION_POLL_INTERVAL_MS = 3000;

export const INSPECTION_FORBIDDEN_MESSAGE =
  "Este imóvel não faz parte da sua carteira.";

export const INSPECTION_FILE_UNAVAILABLE_MESSAGE = "Vistoria ainda não disponível.";

export const INSPECTION_SEARCH_ERROR_MESSAGE =
  "Não foi possível buscar a vistoria agora. Tente novamente em instantes.";

export const INSPECTION_SEARCHING_LABEL = "Buscando…";

export const DEFAULT_SITUATION_LABELS: Record<PortfolioSituation, string> = {
  ALUGADO: "Alugado",
  ALUGANDO: "Alugando",
  EM_RESCISAO: "Em rescisão",
  EM_MANUTENCAO: "Em manutenção",
};

export const DEFAULT_OWNER_PORTFOLIO_QUERY: OwnerPortfolioQuery = {
  situation: null,
  condominium: null,
  sort: "condominium",
  metricsDays: 30,
};

export const PORTFOLIO_SORT_OPTIONS = [
  { value: "condominium", label: "Condomínio" },
  { value: "rent_amount", label: "Valor do aluguel" },
  { value: "days_vacant", label: "Dias vago" },
  { value: "contract_end", label: "Fim do contrato" },
] as const;

export const PORTFOLIO_METRICS_OPTIONS = [
  { value: "30", label: "Funil 30 dias" },
  { value: "60", label: "Funil 60 dias" },
  { value: "90", label: "Funil 90 dias" },
] as const;

export const CONDOMINIUM_ACCENT_CLASSES = [
  "border-l-[#a78bfa]",
  "border-l-[#60a5fa]",
  "border-l-[#4ade80]",
  "border-l-[#fbbf24]",
  "border-l-[#f87171]",
  "border-l-[#22d3ee]",
] as const;
